import { render, staticRenderFns } from "./importModal.vue?vue&type=template&id=0c3524f3&scoped=true&"
import script from "./importModal.vue?vue&type=script&lang=js&"
export * from "./importModal.vue?vue&type=script&lang=js&"
import style0 from "./importModal.vue?vue&type=style&index=0&id=0c3524f3&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c3524f3",
  null
  
)

export default component.exports